import { useState } from 'react';

import ShareOutlined from '@mui/icons-material/ShareOutlined';
import { enqueueSnackbar } from 'notistack';
import { MuiDialog } from '@/shared/ui';

import WidgetButton from '@/shared/ui/primitives/WidgetButton';

import { Z_INDEX } from '@/config/z-index';
import ShareDialogContent from '@/features/_shared/ShareDialog/ShareDialogContent';
import { ShareBlockNames } from '@/features/markets/types';
import { http } from '@/services/http';
import copyToClipboard from '@/shared/lib/copyToClipboard';
import { emailValidator } from '@/shared/lib/format/validators';

export { ShareBlockNames };

export const ShareBlock = ({
  blockName,
  activeTabName,
  shareTabParam
}: {
  activeTabName?: string;
  blockName: ShareBlockNames;
  shareTabParam: string;
}) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [content, setContent] = useState<string>('');
  const [recipient, setRecipient] = useState<string>('');
  const [emailError, setEmailError] = useState<string>('');

  const shareUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?element=${shareTabParam}`;

  const sendEmail = async () => {
    const errorMessage = emailValidator(recipient);
    if (errorMessage) {
      setEmailError(errorMessage);
      return;
    }
    try {
      enqueueSnackbar('Email is sending, please wait...', {
        variant: 'loading'
      });
      setModalOpen(false);
      await http.go.post(`/share`, {
        content,
        recipient,
        url: shareUrl
      });
      enqueueSnackbar('Email sent!', {
        variant: 'success',
        autoHideDuration: 5000
      });
    } catch {
      enqueueSnackbar('Something went wrong!', {
        variant: 'error',
        autoHideDuration: 5000
      });
    }
  };
  const handleCopyToClipboard = () => {
    copyToClipboard(shareUrl, 'Link copied to clipboard!');
  };

  const handleChangeRecipient = (value: string) => {
    setEmailError('');
    setRecipient(value);
  };
  const header = `Share ${activeTabName} ${activeTabName === blockName ? '' : blockName}`;

  return (
    <>
      <WidgetButton
        icon={<ShareOutlined sx={{ fontSize: '14px' }} />}
        title='Share'
        onClick={() => {
          setContent('');
          setEmailError('');
          setRecipient('');
          setModalOpen(true);
        }}
      />
      <MuiDialog
        open={modalOpen}
        slotProps={{
          backdrop: {
            sx: {
              backdropFilter: 'blur(2px)',
              backgroundColor: 'rgba(18, 22, 63, 0.80)'
            }
          }
        }}
        sx={{
          zIndex: Z_INDEX.menu
        }}
        onClose={() => {
          setModalOpen(false);
          setContent('');
          setEmailError('');
          setRecipient('');
        }}
      >
        <ShareDialogContent
          content={content}
          emailError={emailError}
          handleChangeRecipient={e => {
            handleChangeRecipient(e.target.value);
          }}
          header={header}
          recipient={recipient}
          shareUrl={shareUrl}
          onContentChange={e => {
            setContent(e.target.value);
          }}
          onCopyClick={handleCopyToClipboard}
          onSendEmail={sendEmail}
        />
      </MuiDialog>
    </>
  );
};
